export default __webpack_public_path__ + "static/media/close.15f54ed2.png";